import { render, staticRenderFns } from "./InfoPrompt.vue?vue&type=template&id=d9f0e854&scoped=true"
import script from "./InfoPrompt.vue?vue&type=script&lang=js"
export * from "./InfoPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f0e854",
  null
  
)

export default component.exports